module.exports = __webpack_public_path__ + "img/mitaofei.c94146e2.png";